/**
 * [切换环境]
 * @Date 2019/09/03改版
 * @Author Louis
 * @Param {[String]} 环境
 */
// let config = getParamConfig('dev');						// 开发环境
// let config = getParamConfig('test');					// 测试环境
let config = getParamConfig('prod');					// 生产环境

function getParamConfig(env){
	let data = {
		baseUrl: '',
		ip: ''
	};
	switch (env) {
		case 'dev':
			data.baseUrl = "http://127.0.0.1:7979/";
			data.ip = "http://127.0.0.1:8080/";
			break;
		case 'test':
			data.baseUrl = "https://api-testnet.iob.community/iob/";
			data.ip = "https://testnet.iob.community/";
			break;
		case 'prod':
			data.baseUrl = "https://api.iob.community/iob/";
			data.ip = "https://iob.community/";
			break;
		default:
			data.baseUrl = "http://127.0.0.1:7979/";
			data.ip = "http://127.0.0.1:8080/";
			break;
	}
	return data;
}

export default config


// WEBPACK FOOTER //
// ./src/config.js